
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Withdraw from './components/Withdraw';
import Users from './components/Users';
import Settings from './components/Settings';
import PlanCards from './components/PlanCards';
import TeamDetail from './components/TeamDetails';
import AdminDashboard from './components/AdminDashboard';
import TransferDetail from './components/TransferDetails';
import LoginPage from './components/Login';

import Deposits from './components/Deposit';
import Referal from './components/Referal';
import TeamIncome from './components/TeamIncome';
import Income from './components/Income';
import Invest from './components/Invest';
import Wallet from './components/WalletUpdate';
import InvestmentHistory from './components/InvestHistory';
import KYCDataComponent from './components/KYC';
import WithdrawalDataComponent from './components/WithdrawData';
import Platinum from './components/Platinum';
import Ticket from './components/Ticket';
import PlatinumIncome from './components/PlatinumIncome';
import PlatinumTeamIncome from './components/PlatinumTeamIncome';
import NotificationPanel from './components/Notification';

import Roles from './components/Roles';
import AccessDenied from './components/AccessDenied';
import ProtectedRoute from './components/protecedroute';
import Blogs from './components/Blogs';
import GWCCoin from './components/GWCCoin';
import Rank from './components/Rank';
import Mailer from './components/Mailer';
import IncomeStat from './components/IncomeStat';
import ShiftHistory from './components/ShiftHistory';
import PlatinumHistoryDashboard from './components/PlatinumHisotry';
import AuditLogs from './components/AuditLogs';
import CronManager from './components/CronManager';
import CronAudit from './components/CronAudit';
import TargetedCron from './components/TargetedCron';
import DateRangeCron from './components/DateRangeCron';
import IncomeDateShift from './components/IncomeDateShift';
import RecoveryPayout from './components/RecoveryPayout';
import UserActivityLogs from './components/UserActivityLogs';
import Banner from './components/Banner';
import AppVersionManagement from './components/AppVersion';
import Offers from './components/Offers';
import WalletBackup from './components/WalletBackup';


function App() {
  // The panel is also served from a sub-path (/admin) for the test build, so the
  // router has to know where it starts. PUBLIC_URL is empty in the normal build,
  // which leaves routing exactly as it was.
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/access-denied" element={<AccessDenied />} />

        {/* Protected Routes - wrapped with authentication check */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="withdraw" element={<Withdraw />} />
            <Route path="deposit" element={<Deposits />} />
            <Route path="users" element={<Users />} />
            <Route path="settings" element={<Settings />} />
            <Route path="planCards" element={<PlanCards />} />
            <Route path="teamDetails" element={<TeamDetail />} />
            <Route path="transferDetails" element={<TransferDetail />} />

            <Route path="referal" element={<Referal />} />
            <Route path="teamincome" element={<TeamIncome />} />
            <Route path="income" element={<Income />} />
            <Route path="invest" element={<Invest />} />
            <Route path="investHistory" element={<InvestmentHistory />} />
            <Route path="wallet" element={<Wallet />} />
            <Route path="kyc" element={<KYCDataComponent />} />
            <Route path="withdrawData" element={<WithdrawalDataComponent />} />
            <Route path="platinumData" element={<Platinum />} />
            <Route path="ticket" element={<Ticket />} />
            <Route path="platinumIncome" element={<PlatinumIncome />} />
            <Route path="notification" element={<NotificationPanel />} />
            <Route path="platinumIncomeTeam" element={<PlatinumTeamIncome />} />

            <Route path="roles" element={<Roles />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="gwccoin" element={<GWCCoin />} />
            <Route path="rank" element={<Rank />} />
            <Route path="mail" element={<Mailer />} />
            <Route path="incomeStat" element={<IncomeStat />} />
            <Route path="shiftHistory" element={<ShiftHistory />} />
            <Route path="platinumHistory" element={<PlatinumHistoryDashboard />} />
            <Route path="audit-logs" element={<AuditLogs />} />
            <Route path="cron-manager" element={<CronManager />} />
            <Route path="cron-audit" element={<CronAudit />} />
            <Route path="targeted-cron" element={<TargetedCron />} />
            <Route path="daterange-cron" element={<DateRangeCron />} />
            <Route path="income-date-shift" element={<IncomeDateShift />} />
            <Route path="recovery-payout" element={<RecoveryPayout />} />
            <Route path="user-logs" element={<UserActivityLogs />} />
            <Route path="user-logs/:email" element={<UserActivityLogs />} />
            <Route path="banner" element={<Banner />} />
            <Route path="appVersion" element={<AppVersionManagement />} />
            <Route path="offers" element={<Offers />} />
            <Route path="wallet-backup" element={<WalletBackup />} />
          </Route>
        </Route>

        {/* Redirect any unknown routes to login when not authenticated or dashboard when authenticated */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;